import { Component, OnInit } from '@angular/core';
import { FiltroReserva, Paginacao, STATUSRESERVA } from '../../model';
import { ReservaService } from '../../services/';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Util } from './../../services/utils.service';

@Component({// tslint:disable-next-line: component-selector
  selector: 'meus-orcamentos',
  templateUrl: './meus-orcamentos.component.html',
  styleUrls: ['./meus-orcamentos.component.scss'], standalone: false
})

export class MeusOrcamentosComponent implements OnInit {

  filtro: FiltroReserva = new FiltroReserva();
  paginacao: Paginacao = new Paginacao();
  carregando: boolean;
  toogle = true;
  orcamentos = [];
  maxData: any;
  i: number;

  constructor(
    public router: Router,
    private reservaService: ReservaService,
    private modalService: NgbModal,
    private utilService: Util
  ) { }

  ngOnInit() {
    this.maxData = new Date();
    this.maxData.setDate(new Date().getDate());
    this.buscarMeusOrcamentos();
  }

  dataDe: any;
  dataAte: any;
  buscarMeusOrcamentos() {
    this.carregando = true;
    const agencia = window.localStorage.getItem('g8h7d8');
    if (agencia !== null) {
      let a = JSON.parse(atob(agencia));
      this.filtro.AgenciaId = a.Id;
    } else {
      this.filtro.AgenciaId = 0;
    }

    // Limpando para o filtro
    delete this.filtro.Data1;
    delete this.filtro.Data2;

    if (this.dataDe !== undefined) {
      let data = new Date(this.dataDe);
      data.setUTCHours(0, 0, 0, 0); // Usa UTC para evitar ajuste de fuso
      this.filtro.Data1 = data.toISOString();
    }

    if (this.dataAte !== undefined) {
      let data = new Date(this.dataAte);
      data.setUTCHours(23, 59, 59); // Usa UTC para evitar ajuste de fuso
      this.filtro.Data2 = data.toISOString();
    }


    this.reservaService.buscarMeusOrcamentos(this.filtro, this.paginacao.NumeroPagina).subscribe(
      dados => {
        this.paginacao.NumeroPagina = dados.MetaData.NumeroPagina;
        this.paginacao.TotalItens = dados.MetaData.TotalItens;
        this.paginacao.ItensPorPagina = dados.MetaData.itensPorPagina;
        this.paginacao.TotalPaginas = dados.MetaData.TotalPaginas;

        this.carregando = false;
        this.orcamentos = dados.Items;
      },

      erro => console.log(erro)
    );
    this.carregando = false;
  }

  limparFiltro() {
    this.filtro = new FiltroReserva();
    this.dataDe = undefined;
    this.dataAte = undefined;
    this.buscarMeusOrcamentos();
  }

  buscarPagina(pagina) {
    this.paginacao.NumeroPagina = pagina;
    this.buscarMeusOrcamentos();
  }

  acessarOrcamento(event, reserva) {
    event.preventDefault();
    this.router.navigate(['/orcamento/' + reserva.Id]);

  }

  permitirSomenteDatas(event: KeyboardEvent) {
    const regex = /^[0-9]*$/;
    const key = event.key;

    if (!regex.test(key)) {
      event.preventDefault();
    }
  }

  formatarDataManual(event: any) {
    let valor = event.target.value.replace(/\D/g, "");
    let formato = "";
    // let posicaoCursor = event.target.selectionStart;

    if (valor.length >= 2) {
      let dia = parseInt(valor.substring(0, 2), 10);
      if (dia > 31) dia = 31;
      if (dia < 1) dia = 1;
      formato = (dia < 10 ? "0" + dia : dia) + "/";
    } else {
      formato = valor;
    }

    if (valor.length >= 4) {
      let mes = parseInt(valor.substring(2, 4), 10);
      if (mes > 12) mes = 12;
      if (mes < 1) mes = 1;
      formato += (mes < 10 ? "0" + mes : mes) + "/";
    } else if (valor.length > 2) {
      formato += valor.substring(2);
    }

    if (valor.length > 4) {
      let ano = parseInt(valor.substring(4, 8), 10);
      if (valor.length >= 8) {
        if (ano < 1900) ano = 1900;
        if (ano > 2100) ano = 2100;
      }
      formato += ano;
    }

    event.target.value = formato;

    // setTimeout(() => {
    //     event.target.setSelectionRange(posicaoCursor, posicaoCursor);
    // }, 10);
  }

  limpar(event: KeyboardEvent) {
    if (event.key === "Backspace") {
      (event.target as HTMLInputElement).value = "";
      event.preventDefault();
    }
  }

  getStatusClass(itens: { Status: number }[] = []): string {
    if (!itens || itens.length === 0) {
      return 'text-dark';
    }

    const statusDosItens = itens
      .map(item => item.Status)
      .filter(status => status !== undefined && status !== null);

    if (statusDosItens.includes(STATUSRESERVA.PROBLEMATECNICO)) {
      return 'text-danger';
    }

    if (statusDosItens.includes(STATUSRESERVA.AGUARDANDOINTEGRADOR)) {
      return 'text-primary';
    }

    if (statusDosItens.includes(STATUSRESERVA.PARCIALMENTECONFIRMADO)) {
      return 'text-info';
    }
      
    if (statusDosItens.some(s =>
      s === STATUSRESERVA.RESERVADO ||
      s === STATUSRESERVA.CONFIRMADO ||
      s === STATUSRESERVA.EMITIDO ||
      s === STATUSRESERVA.PAGO
    )) {
      return 'text-success'; // Prioridade máxima
    }

    if (
      statusDosItens.includes(STATUSRESERVA.PENDENTE) ||
      statusDosItens.includes(STATUSRESERVA.EXCLUIDA)
    ) {
      return 'text-muted';
    }

    if (statusDosItens.includes(STATUSRESERVA.CANCELADA)) {
      return 'text-warning';
    }

    // if (statusDosItens.includes(STATUSRESERVA.PROBLEMATECNICO)) {
    //   return 'text-danger';
    // }

    return 'text-dark'; // Valor padrão
  }


  getStatus(list: { Status: number }[]): string {
    if (!list || list.length === 0 || list[0].Status === undefined) {
      return 'Desconhecido';
    }

    const statusList = list
      .map(item => item.Status)
      .filter(status => status !== undefined && status !== null);

    if (statusList.some(s =>
      s === STATUSRESERVA.RESERVADO ||
      s === STATUSRESERVA.CONFIRMADO ||
      s === STATUSRESERVA.EMITIDO ||
      s === STATUSRESERVA.PAGO ||
      s === STATUSRESERVA.PARCIALMENTECONFIRMADO
    )) {
      // Prioridade máxima — retorna o primeiro encontrado com prioridade
      const prioridade = list.find(item =>
        [STATUSRESERVA.RESERVADO, STATUSRESERVA.CONFIRMADO, STATUSRESERVA.EMITIDO, STATUSRESERVA.PAGO, STATUSRESERVA.PARCIALMENTECONFIRMADO]
          .includes(item.Status)
      );
      return this.utilService.getEnumLabel(STATUSRESERVA, prioridade.Status);
    }

    // Se nenhum prioritário, retorna o rótulo do primeiro status válido
    const primeiroValido = list.find(item => item.Status !== undefined && item.Status !== null);
    return primeiroValido
      ? this.utilService.getEnumLabel(STATUSRESERVA, primeiroValido.Status)
      : 'Desconhecido';
  }


  itemParaVisualizacao: any;
  abrirModal(content, item) {
    this.reservaService.buscarOrcamento(item.Id).subscribe(
      dados =>{
        this.itemParaVisualizacao = dados
        if (this.itemParaVisualizacao.PacoteReservas[0]?.Pacote != undefined) {
          this.itemParaVisualizacao.PacoteReservas[0].Pacote.PacoteImagens = this.itemParaVisualizacao.PacoteReservas[0].Pacote.PacoteImagens.map(x => {
            x.Imagem = Util.pathImagemApi(x.Imagem);
            return x;
          })
        }
        this.modalService.open(content, { centered: true, size: 'xl' });
      },
      erros => {
        console.log(erros)
      })
  }

  fecharModal() {
    this.modalService.dismissAll();
  }

}
